module.exports = __webpack_public_path__ + "img/accesspark.28e382a6.svg";